export default __webpack_public_path__ + "static/media/battery-empty24x24.977c24ac.svg";